import useServiceCall from '@sprinx/react-api-client/useServiceCall';
import useDefaults from '@sprinx/react-hooks/useDefaults';
import useResolveServiceActionName from '@sprinx/react-api-client/useResolveServiceActionName';
import usePricingContext from '../usePricingContext';
export default function usePricingRulesServiceCallList(options) {
  var _usePricingContext = usePricingContext(),
      clientCode = _usePricingContext.clientCode,
      serviceNames = _usePricingContext.serviceNames;

  var callOptions = useDefaults(options, {
    clientCode: clientCode,
    returnOnlyAction: true
  });
  var serviceName = useResolveServiceActionName(null, 'v1.pricingRules.list', serviceNames);
  return useServiceCall(callOptions, function (client) {
    return client.list(serviceName, {}, {
      method: 'get',
      mockAction: 'list'
    });
  });
}